import { useCallback } from "react";

import { useAppFeatures } from "@/hooks/useAppFeatures";

import { guardPermission } from "./guardPermission";

/**
 * With granular RBAC, wraps an action with the permission-denied toast.
 * With the flag off, returns the action as is.
 */
export const useGuardPermission = () => {
  const { isGranularRbacEnabled } = useAppFeatures();

  return useCallback(
    <Args extends unknown[]>(
      isGranted: boolean,
      action: (...args: Args) => void
    ) => (isGranularRbacEnabled ? guardPermission(isGranted, action) : action),
    [isGranularRbacEnabled]
  );
};
